// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nu-0";
export var animationContainer = "_nu-1";
export var itemPrice = "_nu-a";
export var itemizedContent = "_nu-9";
export var itemizedHeader = "_nu-7";
export var itemizedRow = "_nu-8";
export var itemizedSection = "_nu-6";
export var modalContent = "_nu-2";
export var orderName = "_nu-3";
export var refundOption = "_nu-4";
export var refundOptionsContainer = "_nu-5";
export var shippingLabel = "_nu-b";
export var totalRow = "_nu-c";